import { FiLink } from 'react-icons/fi';
import { unescapeHtmlEntities } from '@/utils/stringUtils';
import Link from 'next/link';
import type { StructuredCard } from './types';

export const LinkCard = ({
  card,
  isClarify,
}: {
  card: StructuredCard & { content: string; title?: string };
  isClarify?: boolean;
}) => {
  let domain = '';
  try {
    domain = new URL(card.content).hostname.replace('www.', '');
  } catch {
    domain = card.title || 'Link';
  }
  const bgClass = isClarify
    ? 'bg-yellow-100 dark:bg-yellow-800/50'
    : 'bg-slate-100 dark:bg-slate-800';
  const borderClass = isClarify
    ? 'border-yellow-200 dark:border-yellow-700'
    : 'border-slate-200 dark:border-slate-700';
  const textClass = isClarify
    ? 'text-yellow-700 dark:text-yellow-300'
    : 'text-slate-500';

  return (
    <Link
      href={card.content}
      title={unescapeHtmlEntities(card.title || card.content)}
      className={`flex items-center gap-1.5 px-2 py-1 ${bgClass} rounded-lg border ${borderClass} ${textClass} hover:text-blue-600 dark:hover:text-blue-400 transition-colors shadow-sm text-xs font-medium`}
    >
      <FiLink size={12} />
      <span>{unescapeHtmlEntities(domain)}</span>
    </Link>
  );
};
